import m from 'mithril';

import s from './styles.module.scss';

const SingleSelect = {};

SingleSelect.oninit = (vnode) => {
    vnode.state.open = false;
};

SingleSelect.onupdate = (vnode) => {
    if (vnode.state.open) {
        function isBelowElement(element) {
            var rect = element.getBoundingClientRect();
            var windowHeight = window.innerHeight || document.documentElement.clientHeight;

            // Check if the element is below the vertical middle point of the viewport
            if (rect.bottom > (windowHeight * 2) / 3) {
                return true;
            }

            return false;
        }

        var myElement = document.getElementById(`modal_${vnode.attrs?.id}`);
        var position = isBelowElement(myElement);
        if (position) {
            const e = document.querySelector(`#modal_${vnode.attrs?.id} .${s.list_options}`);
            e.style.top = 'initial';
            e.style.bottom = '100%';
        }
    }
};

SingleSelect.onupdate = (vnode) => {
    if (vnode.state.open && vnode.attrs?.data) {

		// BEGIN HACK - Replace non-css-friendly characters
		const value_id = /[|&:]/g.test(vnode.attrs?.data?.value ?? '') ? vnode.attrs.data.value.replaceAll(/[|&:]/g, '_') : vnode.attrs?.data?.value
		// END HACK - Replace non-css-friendly characters

        const e = document.querySelector(`#modal_${vnode.attrs?.id} .option_${value_id}`);
        e?.scrollIntoView({ block: 'center' });
    }
};

SingleSelect.view = (vnode) => {
    const { onchange, disabled, options, errors, data, id, custom_classes, allow_wrap, onfocus, onblur, option_class } = vnode.attrs;

    const handleSelectChange = (e, option) => {
        e.preventDefault();
        e.stopPropagation();
        onchange(option);

        vnode.state.open = false;

        if (typeof onblur === 'function') {
            onblur();
        }
    };

    const renderLabel = data?.label;

    return m(
        `div#modal_${id}`,
        {
            class: [s.tod_select, disabled ? s.disabled : '', errors ? s.errors : '', custom_classes].join(' '),
        },
        [
            m(
                'div',
                {
                    class: s.select,
                    onclick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (!vnode.state.open && typeof onfocus === 'function') {
                            onfocus();
                        }
                        vnode.state.open = true;

            
                    },
                },
                typeof renderLabel === 'function' ? renderLabel() : renderLabel
            ),
            vnode.state.open && [
                m('div', { class: s.backdrop, onclick: () => {
                    vnode.state.open = false
                    if (typeof onblur === 'function') {
                        onblur();
                    }
                } }),
                m('div', { class: s.list_options }, [
                    m(
                        'div',
                        { class: s.list_options_container },
                        options.map((option) =>
                            m(
                                `div.option_${option?.value}`,
                                {
                                    key: option?.id,
                                    class: [
										s.select,
										s.select_child,
										option.value === data?.value ? s.active : '',
										allow_wrap ? s.allow_wrap : '',
                                        option_class
									].join(' '),
                                    onclick: (e) => {
                                        handleSelectChange(e, option);
                                    },
                                },
                                typeof option?.label === 'function' ? option?.label() : option?.label
                            )
                        )
                    ),
                ]),
            ],
        ]
    );
};

export default SingleSelect;
